import { Backend, PrimitiveType } from './workflow.type';

import { ErrCallback, FlatData, StorageBackend } from '../class/storage-backend.base';
import { StatefulService } from '@app/service/stateful.service';

/**
 * Backend for storing state in-memory
 */
export class MemoryBackend extends StorageBackend {
  public readonly type: Backend = 'mem';

  constructor(
    protocol: string,
    data: FlatData,
    arraySizes: { [rootPath: string]: number },
    endpointPath: string,
    token: string,
    statefulService: StatefulService // ✅ Ensure this argument is expected
  ) {
    super(protocol, data, arraySizes, endpointPath, token, statefulService); // ✅ Pass it to parent
    // this.logger.info(`MemoryBackend received StatefulService:`, statefulService);
  }

  /**
   * @inheritdoc
   */
  public load(path: string, cb: (err?: Error, data?: PrimitiveType) => void): void {
    this.updateArraySizes.next(null);
    cb(undefined, this.data[`${this.protocol}:${path}`]);
    this.propagateBundle.next();
  }

  /**
   * @inheritdoc
   */
  public save(path: string, value: PrimitiveType, cb: ErrCallback): void {
    this.data[`${this.protocol}:${path}`] = value;
    this.updateArraySizes.next(null);
    this.propagateBundle.next();
    cb();
  }

  /**
   * @inheritdoc
   */
  public init() {
    this.initialized = true;
  }

  public clear(): void {
    Object.keys(this.data).forEach((key) => {
      delete this.data[key];
    });
    this.initialized = false;
  }
}
